import { useEffect, useState } from 'react';

export type Breakpoint = 'mobile' | 'tablet' | 'desktop';

export function useBreakpoint() {
  const [width, setWidth] = useState<number>(typeof window !== 'undefined' ? window.innerWidth : 0);

  useEffect(() => {
    const onResize = () => setWidth(window.innerWidth);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  const isMobile = width < 768; // Tailwind < md
  const isTablet = width >= 768 && width < 1024; // md to < lg
  const isDesktop = width >= 1024; // >= lg

  let current: Breakpoint = 'mobile';
  if (isTablet) current = 'tablet';
  if (isDesktop) current = 'desktop';

  return { width, isMobile, isTablet, isDesktop, current } as const;
}
